/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
const _0x556c=['afterInit','editor','has','TrackChangesEditing','plugins'];(function(_0x197163,_0x556c3b){const _0x301058=function(_0x601e7f){while(--_0x601e7f){_0x197163['push'](_0x197163['shift']());}};_0x301058(++_0x556c3b);}(_0x556c,0xce));const _0x3010=function(_0x197163,_0x556c3b){_0x197163=_0x197163-0x0;let _0x301058=_0x556c[_0x197163];return _0x301058;};import{Plugin as _0x1f83a7}from'ckeditor5/src/core';export default class F extends _0x1f83a7{[_0x3010('0x4')](){const _0xc8d6db=this[_0x3010('0x0')];if(!_0xc8d6db['plugins'][_0x3010('0x1')]('CommentsEditing'))return;_0xc8d6db[_0x3010('0x3')]['get'](_0x3010('0x2'))['enableCommand']('addCommentThread');}}